import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "g-container flex flex-col gap-[20px] sm:gap-[40px]" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-xl sm:text-2xl text-center sm:text-start text-gray-700 sm:font-bold pt-[30px] sm:pt-[45px]" }, " 作品庫 ", -1)
const _hoisted_3 = { class: "relative flex flex-col gap-[30px] sm:gap-[40px]" }
const _hoisted_4 = { class: "filter-search flex flex-col px-[58px] sm:px-0 sm:flex-row gap-4 sm:w-[566px]" }
const _hoisted_5 = { class: "flex flex-col px-[16px] sm:px-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_date_picker = _resolveComponent("date-picker")!
  const _component_SearchInput = _resolveComponent("SearchInput")!
  const _component_ProductClassItemList = _resolveComponent("ProductClassItemList")!
  const _component_PortfolioItemList = _resolveComponent("PortfolioItemList")!
  const _component_ModalConfirm = _resolveComponent("ModalConfirm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_date_picker, {
            "prefix-class": "xmx",
            value: _ctx.timeRange,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.timeRange) = $event)),
            "disabled-date": _ctx.disabledAfterToday,
            lang: _ctx.langString,
            clearable: false,
            placeholder: '請選擇日期',
            range: ""
          }, null, 8, ["value", "disabled-date", "lang"]),
          _createVNode(_component_SearchInput, {
            getInput: _ctx.getInput,
            "onUpdate:getInput": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.getInput) = $event))
          }, null, 8, ["getInput"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_ProductClassItemList),
          _createVNode(_component_PortfolioItemList, {
            editPortfolioName: _ctx.editPortfolioName,
            "onUpdate:editPortfolioName": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.editPortfolioName) = $event)),
            portfolioList: _ctx.portfolioList,
            "onUpdate:portfolioList": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.portfolioList) = $event)),
            continueEdit: _ctx.continueEdit,
            "onUpdate:continueEdit": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.continueEdit) = $event)),
            copyPortfolio: _ctx.copyPortfolio,
            "onUpdate:copyPortfolio": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.copyPortfolio) = $event)),
            delPortfolio: _ctx.delPortfolio,
            "onUpdate:delPortfolio": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.delPortfolio) = $event)),
            class: "hidden sm:block"
          }, null, 8, ["editPortfolioName", "portfolioList", "continueEdit", "copyPortfolio", "delPortfolio"]),
          _createVNode(_component_PortfolioItemList, {
            editPortfolioName: _ctx.editPortfolioName,
            "onUpdate:editPortfolioName": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.editPortfolioName) = $event)),
            portfolioList: _ctx.portfolioList,
            "onUpdate:portfolioList": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.portfolioList) = $event)),
            continueEdit: _ctx.continueEdit,
            "onUpdate:continueEdit": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.continueEdit) = $event)),
            copyPortfolio: _ctx.copyPortfolio,
            "onUpdate:copyPortfolio": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.copyPortfolio) = $event)),
            delPortfolio: _ctx.delPortfolio,
            "onUpdate:delPortfolio": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.delPortfolio) = $event)),
            class: "sm:hidden",
            row: 2
          }, null, 8, ["editPortfolioName", "portfolioList", "continueEdit", "copyPortfolio", "delPortfolio"])
        ])
      ])
    ]),
    _createVNode(_component_ModalConfirm, { ref: "confirmModal" }, null, 512)
  ], 64))
}